let currency: CurrencyFn = (amount, currencySymbol = '$') => `${currencySymbol}${amount}`;

type CurrencyFn = (amount: number, currencySymbol?: string) => string;

export const setCurrencyFn = (currencyFn: CurrencyFn) => {
    currency = currencyFn;
};

/**
 * @deprecated This hook is deprecated. Use Intl.NumberFormat or other currency formatting utilities like formatCurrency from studio_react/invoice/utils instead.
 */
const useCurrency = () => {
    return currency;
};

export default useCurrency;
